<template>
  <div class="br-subleft overflow-y-auto" :data-min="leftStatus">
    <!--<div
      class="left-side-switch"
      onclick="sideChangeStatus();"
    >
      <i
        class="fa"
        :class="leftStatus ? 'fa-angle-double-right':'fa-angle-double-left'"
      ></i>
    </div>-->
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <select-distributor
            class="mg-b-10"
            :noLike="true"
            :key_word="keyDistributorName"
            @changeKeyword="changeName"
            @keywordEnter="filtrateName"
            @keywordFilter="filtrateNameDefault"
          />
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark mg-b-10"
            v-model="keyStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("mall.全部") }}</option>
            <option v-for="(s, k) in msgStatus" :key="k" :value="k">
              {{ s }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("mall.筛 选") }}
    </button>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
export default {
  props: ["leftStatus", "distributorName", "status", "msgStatus"],
  data() {
    return {
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      keyStatus: "",
    };
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
  },
  watch: {
    distributorName() {
      this.keyDistributorName = this.keyDistributorName1 = this.distributorName;
    },
    status() {
      this.keyStatus = this.status;
    },
  },
  methods: {
    changeName(name, id) {
      this.keyDistributorName = name;
      this.keyDistributorId = id;
      //    if (name != this.distributor_name) this.keyDistributorId = "";
    },
    filtrateName(name, id) {
      if (name && name == this.distributorName) {
        this.filtrate();
        return;
      }
      if (!id || id == "e999") {
        if (id == "e999") ShowTip(this.$t("mall.没有匹配的供应商"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按供应商名
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    filtrate() {
      if (!this.keyDistributorId) {
        this.keyDistributorName = "";
        this.keyDistributorId = this.keyDistributorId1;
        this.keyDistributorName = this.keyDistributorName1;
        this.$emit(
          "filtrate",
          this.keyStatus,
          this.keyDistributorName1,
          this.keyDistributorId1
        );
      } else {
        if (!this.keyDistributorId1) {
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName,
            this.keyDistributorId
          );
        } else {
          this.keyDistributorName = "";
          this.keyDistributorId = this.keyDistributorId1;
          this.keyDistributorName = this.keyDistributorName1;
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName1,
            this.keyDistributorId1
          );
        }
      }
    },
  },
};
</script>
